export const IS_MENU_OPEN = 'IS_MENU_OPEN'
export const INCREMENT_COUNT_CLICK = 'INCREMENT_COUNT_CLICK'
export const CURRENT_SECTION_INDEX = 'CURRENT_SECTION_INDEX'
export const WELCOME_POPUP_IS_OPEN = 'WELCOME_POPUP_IS_OPEN'
